module.exports = __webpack_public_path__ + "img/sau-koinobori.65c8cd5.jpg";